import { Shimmer } from '@components';

import { Container, Divider } from '../../TagsManagement.styles';

const TagsLoading = () => {
  return (
    <Container>
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Divider height="16px" />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Divider height="16px" />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Divider height="16px" />
      <Shimmer
        style={{ height: 48, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};

const CountLoading = () => {
  return (
    <Shimmer
      style={{ height: 18, width: 18, borderRadius: 4, marginLeft: 12 }}
      primary="#f1f1f1"
      secondary="#ececec"
    />
  );
};

export { TagsLoading, CountLoading };
